<app-bread-crumb [items]="[{text:  'clubes',link:'/admin/clubs'},{text:'detalhe'}]"
  [sectionTitle]="'Detalhe do Clube'"></app-bread-crumb>

<section class="content">

  <div class="row">

    <div class="col-md-4">
      <!-- Profile Image -->
      <div class="box box-success" style="border-top: 2px solid #f35309;">

        <div class="box-body box-profile">

          <img 
            class="img-responsive" 
            style="width:150px ;height:150px ; margin:0 auto;border-radius:50%;border:1px solid #f7814a;" 
            [src]="club.picture || 'http://localhost:4200/assets/Khuzela.png'"
            alt="imagem do parceiro">

          <h3 class="profile-username text-center">{{club?.name}}</h3>

          <ul class="list-group list-group-unbordered">
            <li class="list-group-item text-center" [ngStyle]="{backgroundColor: club.color,color:'white'}"><strong>Cor Predominante</strong></li>

            <li class="list-group-item">

              <div class="upload-btn-wrapper">

                <button class="btn btn-outline-danger btn-block">
                  <i class="fa fa-cloud-upload"></i> Clique aqui para actualizar o logotipo
                </button>
    
                <input title="" type="file" #iptFile (input)="updateImageProfile($event,club)"/>
              </div>

            </li>
          </ul>

        </div>
        <!-- /.box-body -->
      </div>
      <!-- /.box -->
    </div>


    <div class="col-md-8">

      <div class="box box-widget widget-user-2" style="border-top: 2px solid #f35309;">

        <div class="box-footer no-padding">
          <ul class="nav nav-stacked">
            <li><a href="javascript:void(0);"><strong>Nuit</strong> <span class="pull-right">{{club?.nuit}}</span></a></li>
            <li><a href="javascript:void(0);"><strong>Telefone</strong> <span class="pull-right">{{club?.phone}}</span></a></li>
            <li><a href="javascript:void(0);"><strong>Provincia</strong> <span class="pull-right">{{club?.city?.name}}</span></a></li>
            <li><a href="javascript:void(0);"><strong>Endereço</strong> <span class="pull-right">{{club?.address}}</span></a></li>
            <li><a href="javascript:void(0);"><strong>Nome do Responsável</strong> <span class="pull-right">{{club?.responsible_name}}</span></a></li>
            <li><a href="javascript:void(0);"><strong>Telefone do Responsável</strong> <span class="pull-right">{{club?.responsible_phone}}</span></a></li>
            <li><a href="javascript:void(0);"><strong>Email do Responsável</strong> <span class="pull-right">{{club?.responsible_email}}</span></a></li>
            <li><a href="javascript:void(0);"><strong>Criado em:</strong> <span class="pull-right">{{club?.created_at | date:'dd/MM/yyyy HH:mm:ss'}}</span></a></li>
            <li class="botao">
              <button type="button" (click)="editClub(club)" class="btn btn-outline-danger pull-right"><strong><i
                    class="fa fa-edit"></i> Editar</strong></button>
            </li>
          </ul>

        </div>

      </div>

    </div>

  </div>

</section>